import { addSeconds } from 'date-fns'
import { AuthenticationResult } from '../../core/types/authentication-result'
import { Mappable, Mapped } from '../decorators/mapped'

@Mapped({})
export class AuthToken extends Mappable {
  token!: string
  refresh!: string
  expiresAt!: Date

  static fromResult(result: AuthenticationResult) {
    if (!result.access_token || !result.expires_in) {
      return null
    }
    return new AuthToken().map({
      token: result.access_token,
      refresh: result.refresh_token,
      expiresAt: addSeconds(new Date(), result.expires_in),
    })
  }
}
